import axios, { AxiosInstance } from 'axios';
import createHttpError from 'http-errors';
import type { NextApiRequest } from 'next';

/**
 * Takes an Express HTTP Request, and returns an Axios instance pre-configured for Looker API calls
 * @param req
 * @returns pre-configured Axios instance for Looker API calls
 */
export function initialiseToken(req: NextApiRequest): Promise<AxiosInstance> {
  const auth_token = req.headers.auth_token || req.session?.user_auth_token;
  if (!auth_token) {
    const badRequest = new createHttpError.BadRequest('Missing auth_token in header');
    throw badRequest;
  }
  const user_auth_token = auth_token as string;
  return initializeWithAuthToken(user_auth_token);
}

/**
 *
 * @param authToken auth_token from HTTP request headers
 * @returns pre-configured Axios instance for Looker API calls
 */
export async function initializeWithAuthToken(authToken: string): Promise<AxiosInstance> {
  try {
    if (authToken) {
      const instance = axios.create({
        baseURL: `${process.env.NEXT_PUBLIC_LOOKER_API_URL}/api/4.0`,
        headers: {
          Authorization: `Bearer ${authToken}`,
          'content-type': 'application/json',
        },
      });

      return instance;
    } else {
      console.log('initialiseToken : error', 'User requires authentication');
      throw new Error('User requires authentication');
    }
  } catch (err) {
    console.log('initialiseToken : error', err);
    throw err;
  }
}

export function adminAxios(): Promise<AxiosInstance> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios.post(
        `${process.env.NEXT_PUBLIC_LOOKER_API_URL}/api/4.0/login?client_id=${process.env.LOOKER_CLIENT_KEY}&client_secret=${process.env.LOOKER_SECRET_KEY}`,
        {}
      );

      const token = resp.data.access_token;

      const instance = axios.create({
        baseURL: `${process.env.NEXT_PUBLIC_LOOKER_API_URL}/api/4.0`,
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
        },
      });

      resolve(instance);
    } catch (err) {
      console.log('initialiseToken : error', err);
      reject(err);
    }
  });
}
